module.exports = __webpack_public_path__ + "static/media/fragomen.99c9b2cf.png";